// refquest-popups.js
// Две модалки для реферального квеста Colibri:
// A — большая "Хотите получить подарок?" (центр, затемнение)
// B — маленькая "Ваш друг участвует в квесте" (сбоку), только для гостей по ?ref=
//
// Важно: модалки не мешают загрузке:
// - инициализация после DOMContentLoaded
// - сами модалки появляются с задержкой (2–3 сек)

(function () {
  if (window.ColibriRefQuestPopupsInit) return;
  window.ColibriRefQuestPopupsInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    // ---------- locale ----------
    const rawLang = (document.documentElement.lang || 'ru').toLowerCase();
    const locale = rawLang.split('-')[0];

    const I18N = {
      ru: {
        // Большая модалка A
        bigTitle: 'Хотите получить подарок от Colibri?',
        bigText:
          'Участвуйте в реферальном квесте: приглашайте друзей, собирайте их регистрации и забирайте подарок из специальной коллекции.',
        bigYes: 'Получить подарок',
        bigNo: 'Не сейчас',

        // Маленькая плашка B
        smallTitle: 'Ваш друг участвует в квесте',
        smallText:
          'Ваш друг участвует в квесте Colibri и может получить подарок. Зарегистрируйтесь, получите 5 € на баланс и помогите ему приблизиться к подарку.',
        smallBtnMain: 'Зарегистрироваться',
        smallBtnClose: 'Закрыть',

        ariaClose: 'Закрыть',
      },
      en: {
        bigTitle: 'Want to get a gift from Colibri?',
        bigText:
          'Join the referral quest: invite friends, collect their registrations and claim your gift from a special collection.',
        bigYes: 'Get my gift',
        bigNo: 'Not now',

        smallTitle: 'Your friend is in the quest',
        smallText:
          'Your friend is taking part in the Colibri quest and can get a gift. Sign up, get €5 on your balance and help your friend move closer to the gift.',
        smallBtnMain: 'Sign up',
        smallBtnClose: 'Close',
        ariaClose: 'Close',
      },
      fr: {
        bigTitle: 'Vous voulez recevoir un cadeau de Colibri ?',
        bigText:
          'Participez à la quête de parrainage : invitez vos amis, collectez leurs inscriptions et récupérez votre cadeau dans une collection spéciale.',
        bigYes: 'Obtenir mon cadeau',
        bigNo: 'Pas maintenant',

        smallTitle: 'Votre ami participe à la quête',
        smallText:
          'Votre ami participe à la quête Colibri et peut recevoir un cadeau. Inscrivez-vous, recevez 5 € sur votre solde et aidez-le à se rapprocher du cadeau.',
        smallBtnMain: "S'inscrire",
        smallBtnClose: 'Fermer',
        ariaClose: 'Fermer',
      },
      nl: {
        bigTitle: 'Wil je een cadeau van Colibri?',
        bigText:
          'Doe mee aan de referral-quest: nodig vrienden uit, verzamel registraties en haal je cadeau uit een speciale collectie.',
        bigYes: 'Cadeau krijgen',
        bigNo: 'Niet nu',

        smallTitle: 'Je vriend doet mee aan de quest',
        smallText:
          'Je vriend doet mee aan de Colibri-quest en kan een cadeau krijgen. Registreer, ontvang €5 tegoed en help je vriend dichter bij het cadeau te komen.',
        smallBtnMain: 'Registreren',
        smallBtnClose: 'Sluiten',
        ariaClose: 'Sluiten',
      },
      de: {
        bigTitle: 'Möchtest du ein Geschenk von Colibri?',
        bigText:
          'Nimm an der Empfehlungs-Quest teil: lade Freunde ein, sammle ihre Registrierungen und hole dir dein Geschenk aus einer Spezialkollektion.',
        bigYes: 'Geschenk erhalten',
        bigNo: 'Nicht jetzt',

        smallTitle: 'Dein Freund macht bei der Quest mit',
        smallText:
          'Dein Freund nimmt an der Colibri-Quest teil und kann ein Geschenk bekommen. Registriere dich, erhalte 5 € Guthaben und hilf deinem Freund, dem Geschenk näherzukommen.',
        smallBtnMain: 'Registrieren',
        smallBtnClose: 'Schließen',
        ariaClose: 'Schließen',
      },
    };

    const dict = I18N[locale] || I18N.ru;

    // ---------- читаем состояние до вставки CSS/DOM, чтобы не тратить ресурсы зря ----------

    const params = new URLSearchParams(window.location.search);
    const hasRefParam = !!params.get('ref');

    const customerId =
      (window.colibriRefQuest && window.colibriRefQuest.customerId) ||
      window.colibriCustomerId ||
      null;
    const isLoggedIn = !!customerId;

    const inviteSeen = localStorage.getItem('refquest_invite_seen') === '1'; // видел ли большую
    const refGuestClosed = localStorage.getItem('refquest_ref_guest_closed') === '1'; // закрыл маленькую

    // Маленькая: только гость и только с ?ref, и не закрывал раньше
    const shouldShowSmall = hasRefParam && !isLoggedIn && !refGuestClosed;

    // Большая: всем (гость/клиент), кто ещё не видел, НО не тем, кто сейчас по ?ref гостем
    const shouldShowBig = !inviteSeen && !shouldShowSmall;

    // Если вообще ничего показывать не надо — выходим, даже CSS не вставляем
    if (!shouldShowSmall && !shouldShowBig) {
      return;
    }

    // ---------- CSS (подключаем только если хоть одна модалка нужна) ----------

    const css = `
    /* Общий стиль */

    .refquest-overlay {
      position: fixed;
      inset: 0;
      background: radial-gradient(circle at top, rgba(59,130,246,0.24), transparent 55%),
                  radial-gradient(circle at bottom, rgba(236,72,153,0.24), transparent 60%),
                  rgba(15,23,42,0.58);
      backdrop-filter: blur(6px);
      z-index: 4000;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      pointer-events: none;
      transition: opacity .25s ease;
    }
    .refquest-overlay--show {
      opacity: 1;
      pointer-events: auto;
    }

    .refquest-modal {
      background: radial-gradient(circle at top left,#f9fafb,#ffffff);
      border-radius: 22px;
      padding: 22px 20px 18px;
      max-width: 420px;
      width: calc(100% - 32px);
      box-shadow: 0 20px 60px rgba(15,23,42,0.45);
      position: relative;
      transform: translateY(12px) scale(.96);
      opacity: 0;
      transition: transform .28s ease, opacity .28s ease;
      overflow: hidden;
    }
    .refquest-overlay--show .refquest-modal {
      transform: translateY(0) scale(1);
      opacity: 1;
    }
    .refquest-modal__ribbon {
      position:absolute;
      inset:0;
      background: radial-gradient(circle at 0 0,rgba(59,130,246,.18),transparent 55%),
                  radial-gradient(circle at 100% 0,rgba(236,72,153,.18),transparent 55%);
      opacity:.9;
      pointer-events:none;
    }
    .refquest-modal__content {
      position: relative;
      z-index: 1;
    }
    .refquest-modal__close {
      position:absolute;
      top:10px;
      right:10px;
      width:30px;
      height:30px;
      border-radius:999px;
      border:1px solid rgba(148,163,184,.5);
      background:rgba(255,255,255,.9);
      display:flex;
      align-items:center;
      justify-content:center;
      cursor:pointer;
      font-size:16px;
      color:#0f172a;
    }
    .refquest-modal__icon {
      width:52px;
      height:52px;
      border-radius:18px;
      background: radial-gradient(circle at 30% 0,#f97316,#ec4899);
      display:flex;
      align-items:center;
      justify-content:center;
      color:#fff;
      font-size:28px;
      margin-bottom:8px;
      box-shadow:0 10px 30px rgba(248,113,113,.45);
    }
    .refquest-modal__title {
      font-size:22px;
      font-weight:800;
      margin:4px 0 6px;
      letter-spacing:.02em;
      color:#0f172a;
    }
    .refquest-modal__text {
      font-size:14px;
      line-height:1.5;
      color:#4b5563;
      margin-bottom:16px;
    }
    .refquest-modal__actions {
      display:flex;
      gap:10px;
      justify-content:flex-end;
      flex-wrap:wrap;
    }
    .refquest-btn {
      border-radius:999px;
      border:0;
      padding:9px 16px;
      font-size:14px;
      font-weight:600;
      cursor:pointer;
      display:inline-flex;
      align-items:center;
      justify-content:center;
      gap:6px;
      white-space:nowrap;
    }
    .refquest-btn--primary {
      background: linear-gradient(135deg,#4f46e5,#ec4899);
      color:#fff;
      box-shadow:0 10px 30px rgba(79,70,229,.4);
    }
    .refquest-btn--ghost {
      background:rgba(15,23,42,0.03);
      color:#0f172a;
    }

    /* Маленькая плашка B */
    .refquest-banner {
      position: fixed;
      top: 111px;
      right: 16px;
      z-index: 4001;
      max-width: 320px;
      width: calc(100% - 32px);
      background:#ffffff;
      border-radius:18px;
      box-shadow: 0 14px 40px rgba(15,23,42,0.45);
      padding:12px 14px 12px 14px;
      border:1px solid rgba(148,163,184,0.45);
      display:flex;
      flex-direction:column;
      gap:8px;
      transform: translateX(120%);
      opacity: 0;
      transition: transform .35s ease, opacity .35s ease;
    }
    .refquest-banner--show {
      transform: translateX(0);
      opacity: 1;
    }
    .refquest-banner__top {
      display:flex;
      gap:10px;
      align-items:flex-start;
    }
    .refquest-banner__badge {
      width:28px;
      height:28px;
      border-radius:999px;
      background: radial-gradient(circle at 30% 0,#22c55e,#3b82f6);
      color:#fff;
      display:flex;
      align-items:center;
      justify-content:center;
      font-size:17px;
      flex-shrink:0;
    }
    .refquest-banner__title {
      font-size:14px;
      font-weight:700;
      color:#0f172a;
      margin-bottom:2px;
    }
    .refquest-banner__text {
      font-size:13px;
      color:#4b5563;
      line-height:1.45;
    }
    .refquest-banner__close {
      margin-left:auto;
      margin-top:-4px;
      margin-right:-4px;
      width:26px;
      height:26px;
      border-radius:999px;
      border:0;
      background:transparent;
      display:flex;
      align-items:center;
      justify-content:center;
      cursor:pointer;
      color:#64748b;
      font-size:16px;
    }
    .refquest-banner__bottom {
      display:flex;
      justify-content:flex-end;
      margin-top:4px;
    }
    .refquest-banner__btn-main {
      border-radius:999px;
      border:0;
      padding:7px 14px;
      font-size:13px;
      font-weight:600;
      cursor:pointer;
      background: linear-gradient(135deg,#22c55e,#16a34a);
      color:#fff;
      box-shadow:0 8px 20px rgba(34,197,94,0.45);
    }

    @media (max-width: 600px) {
      .refquest-banner {
        top: auto;
        bottom: 16px;
        right: 12px;
        left: 12px;
        max-width: none;
      }
    }
    `;

    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    // ---------- фабрика модалки A (большая) ----------

    function showBigInviteModal() {
      if (document.querySelector('.refquest-overlay')) return;

      const overlay = document.createElement('div');
      overlay.className = 'refquest-overlay';

      const modal = document.createElement('div');
      modal.className = 'refquest-modal';

      const ribbon = document.createElement('div');
      ribbon.className = 'refquest-modal__ribbon';

      const content = document.createElement('div');
      content.className = 'refquest-modal__content';

      const closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'refquest-modal__close';
      closeBtn.setAttribute('aria-label', dict.ariaClose);
      closeBtn.textContent = '×';

      const icon = document.createElement('div');
      icon.className = 'refquest-modal__icon';
      icon.textContent = '🎁';

      const title = document.createElement('div');
      title.className = 'refquest-modal__title';
      title.textContent = dict.bigTitle;

      const text = document.createElement('div');
      text.className = 'refquest-modal__text';
      text.textContent = dict.bigText;

      const actions = document.createElement('div');
      actions.className = 'refquest-modal__actions';

      const btnYes = document.createElement('button');
      btnYes.type = 'button';
      btnYes.className = 'refquest-btn refquest-btn--primary';
      btnYes.textContent = dict.bigYes;

      const btnNo = document.createElement('button');
      btnNo.type = 'button';
      btnNo.className = 'refquest-btn refquest-btn--ghost';
      btnNo.textContent = dict.bigNo;

      actions.appendChild(btnNo);
      actions.appendChild(btnYes);

      content.appendChild(closeBtn);
      content.appendChild(icon);
      content.appendChild(title);
      content.appendChild(text);
      content.appendChild(actions);

      modal.appendChild(ribbon);
      modal.appendChild(content);
      overlay.appendChild(modal);
      document.body.appendChild(overlay);

      requestAnimationFrame(() => {
        overlay.classList.add('refquest-overlay--show');
      });

      function closeAll() {
        overlay.classList.remove('refquest-overlay--show');
        setTimeout(() => overlay.remove(), 200);
      }

      function rememberSeen() {
        // записываем, что большую уже показывали
        localStorage.setItem('refquest_invite_seen', '1');
      }

      closeBtn.addEventListener('click', () => {
        rememberSeen();
        closeAll();
      });

      btnNo.addEventListener('click', () => {
        rememberSeen();
        closeAll();
      });

      btnYes.addEventListener('click', () => {
        rememberSeen();
        window.location.href = '/pages/refquest';
      });

      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          rememberSeen();
          closeAll();
        }
      });
    }

    // ---------- фабрика модалки B (маленькая плашка) ----------

    function showSmallRefBanner() {
      if (document.querySelector('.refquest-banner')) return;

      const box = document.createElement('div');
      box.className = 'refquest-banner';

      const top = document.createElement('div');
      top.className = 'refquest-banner__top';

      const badge = document.createElement('div');
      badge.className = 'refquest-banner__badge';
      badge.textContent = '🤝';

      const textWrap = document.createElement('div');

      const title = document.createElement('div');
      title.className = 'refquest-banner__title';
      title.textContent = dict.smallTitle;

      const text = document.createElement('div');
      text.className = 'refquest-banner__text';
      text.textContent = dict.smallText;

      textWrap.appendChild(title);
      textWrap.appendChild(text);

      const closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'refquest-banner__close';
      closeBtn.setAttribute('aria-label', dict.ariaClose);
      closeBtn.textContent = '×';

      top.appendChild(badge);
      top.appendChild(textWrap);
      top.appendChild(closeBtn);

      const bottom = document.createElement('div');
      bottom.className = 'refquest-banner__bottom';

      const mainBtn = document.createElement('button');
      mainBtn.type = 'button';
      mainBtn.className = 'refquest-banner__btn-main';
      mainBtn.textContent = dict.smallBtnMain;

      bottom.appendChild(mainBtn);

      box.appendChild(top);
      box.appendChild(bottom);
      document.body.appendChild(box);

      requestAnimationFrame(() => {
        box.classList.add('refquest-banner--show');
      });

      function closeBanner() {
        box.classList.remove('refquest-banner--show');
        setTimeout(() => box.remove(), 220);
      }

      function rememberClosed() {
        localStorage.setItem('refquest_ref_guest_closed', '1');
      }

      closeBtn.addEventListener('click', () => {
        rememberClosed();
        closeBanner();
      });

      mainBtn.addEventListener('click', () => {
        rememberClosed();
        window.location.href = '/account/register';
      });
    }

 

    // Маленькая — только гостю по ?ref, если он её ещё не закрывал.
    if (shouldShowSmall) {
      // задержка ~2 секунды после загрузки
      setTimeout(showSmallRefBanner, 2000);
      return; // в этот заход большую не трогаем
    }

    // Большая — всем остальным (гости и залогиненные), кто её ещё не видел.
    if (shouldShowBig) {
      // задержка ~3 секунды после загрузки
      setTimeout(showBigInviteModal, 3000);
    }
  });
})();
